import { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { getProducts } from '@services/product.service'
import { deleteProduct } from '@services/admin.service'
import './Products.scss'

function formatMoney(amount) {
  return new Intl.NumberFormat('ro-RO', { style: 'currency', currency: 'RON' }).format(amount ?? 0)
}

export default function AdminProducts() {
  const [items, setItems] = useState([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)
  const [search, setSearch] = useState('')

  async function loadProducts() {
    setLoading(true)
    setError(null)
    try {
      const res = await getProducts({ search: search || undefined, pageSize: 200 })
      const list = res?.data?.items ?? res?.items ?? []
      setItems(Array.isArray(list) ? list : [])
    } catch (e) {
      setError(e.response?.data?.message || e.message || 'Eroare la încărcare')
      setItems([])
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    loadProducts()
    // eslint-disable-next-line react-hooks/exhaustive-deps -- mount + explicit handleSearch/delete refresh
  }, [])

  const handleSearch = (e) => {
    e.preventDefault()
    loadProducts()
  }

  const handleDelete = async (product) => {
    const confirmed = window.confirm(`Sigur ștergi produsul „${product.name}"?`)
    if (!confirmed) return
    try {
      await deleteProduct(product.id)
      loadProducts()
    } catch (e) {
      alert(e.response?.data?.message || e.message || 'Eroare la ștergere')
    }
  }

  return (
    <div className="admin-page">
      <div className="admin-card products-toolbar">
        <form className="products-toolbar__form" onSubmit={handleSearch}>
          <input
            type="text"
            className="products-toolbar__search"
            placeholder="Caută produse..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
          <button type="submit" className="btn-primary">Caută</button>
        </form>
        <Link to="/admin/products/new" className="btn-primary">Adaugă produs</Link>
      </div>

      {error && <p className="admin-page__error">{error}</p>}
      {loading ? (
        <p>Se încarcă...</p>
      ) : (
        <div className="admin-card">
          <table className="admin-table">
            <thead>
              <tr>
                <th>Nume</th>
                <th>Preț</th>
                <th>Stoc</th>
                <th>Categorie</th>
                <th>Featured</th>
                <th>Acțiuni</th>
              </tr>
            </thead>
            <tbody>
              {items.length === 0 ? (
                <tr>
                  <td colSpan={6}>Niciun produs găsit.</td>
                </tr>
              ) : (
                items.map((p) => (
                  <tr key={p.id}>
                    <td>{p.name}</td>
                    <td>{formatMoney(p.price)}</td>
                    <td>{p.stock_quantity ?? '—'}</td>
                    <td>{p.category_id ?? '—'}</td>
                    <td>{p.is_featured ? <span className="admin-badge status-confirmed">Da</span> : '—'}</td>
                    <td>
                      <Link to={`/admin/products/${p.id}/edit`} className="products-table__link">Editează</Link>
                      {' · '}
                      <button type="button" className="products-table__btn" onClick={() => handleDelete(p)}>
                        Șterge
                      </button>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      )}
    </div>
  )
}
